import * as React from 'react';
import {
  withStyles,
  Arwes,
  Content,
  Row,
  Col,
  Words,
  Frame,
  Image,
  Button,
  Loading,
  createLoader,
  createResponsive,
  utils,
} from 'arwes';
import { Machine, assign } from 'xstate';
import { useMachine } from '@xstate/react';
import Falcon from '../components/falcon';
import AssembledFalcon from '../components/assembled-falcon';
import Link from '../components/link';
import TextIcon from '../components/text-icon';

interface ToggleContext {
  count: number;
}

const toggleMachine = Machine<ToggleContext>({
  id: 'toggle',
  initial: 'inactive',
  context: {
    count: 0,
  },
  states: {
    inactive: {
      on: { TOGGLE: 'active' },
    },
    active: {
      entry: assign({ count: ctx => ctx.count + 1 }),
      on: { TOGGLE: 'inactive' },
    },
  },
});

const styles = theme => {
  console.log('MAIN THEME: ', theme);
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'row',
    },
    main: {
      margin: '40px',
      width: '100%',
    },
    fullHeightColumn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      flexDirection: 'column',
    },
    videoColumn: {
      overflow: 'hidden',
      position: 'relative',
    },
    falconVideo: {
      objectFit: 'cover',
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      top: 0,
      left: 0,
      transform: 'translate(-400px, -30px) scale(0.9)',
    },
    content: {
      margin: 'auto',
      padding: theme.padding,
      textAlign: 'center',
      maxWidth: 700,
      '& h1': {
        margin: 0,
        paddingTop: 5,
        fontSize: 44,
        lineHeight: '1',
      },
      '& p': {
        margin: 0,
      },
      '& $detail + $detail': {
        marginTop: theme.margin / 2,
      },
    },
    section: {
      padding: '0 50px',

      '& span': {
        fontSize: 40,
      },
    },
    falcon9: {
      position: 'relative',
      marginBottom: 0,
      '& img': {
        height: 'calc(100vh - 140px)',
        width: 'auto',
      },
    },
    frame: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
    },
    enterButton: {
      display: 'inline-block',
      margin: '32px auto 0',

      '& button': {
        fontSize: 32,
        textTransform: 'uppercase',
      },
    },
    detail: {
      display: 'block',
    },
    textIcon: {
      textAlign: 'center',
    },
    button: {
      width: '50%',
    },
    // medium size +
    [`@media screen and (min-width: ${theme.responsive.small + 1}px)`]: {
      content: {
        '& $detail + $detail': {
          margin: [0, 0, 0, theme.margin / 2],
        },
      },
      detail: {
        display: 'inline-block',
      },
      button: {
        width: 'auto',
      },
    },
  };
};

class Main extends React.Component<any, any> {
  public falcon9;
  public loader;
  public responsive;

  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      loaded: false,
    };

    console.log('PROPS: ', this.props);

    this.falcon9 = '/assets/falcon9-complete.png';

    this.loader = createLoader();
    this.responsive = createResponsive({
      getTheme: () => this.props.theme,
    });
  }

  componentDidMount() {
    this.startLoading();
  }

  startLoading() {
    const responsive = this.responsive.get();
    const background = utils.getResponsiveResource(this.props.resources.background, responsive);

    this.loader
      .load({ images: [background, this.falcon9] }, { timeout: 5 * 1000 })
      .then(
        () => {},
        () => {},
      )
      .then(() => {
        setTimeout(() => {
          this.setState({ show: true, loaded: true });
        }, 3000);
      });
  }

  onLink = () => {
    this.setState({ show: false });
  };

  render() {
    const { show, loaded } = this.state;

    const { classes, resources } = this.props;
    const { background, pattern } = resources;

    console.log('PROPS RENDER: ', this.props);

    return (
      <div className="main">
        {/* <div className="falcon9-complete">
              <AssembledFalcon />
            </div> */}
        <Loading
          full
          animate
          show={!show && !loaded}
          animation={{
            unmountOnExit: true,
          }}
        />
        <Arwes animate show={show} showResources={show} background={background} pattern={pattern}>
          {anim => (
            <Content className={classes.root}>
              <Row className={classes.main}>
                <Col s={6} className={`${classes.fullHeightColumn} ${classes.videoColumn}`}>
                  <Frame animate show={anim.entered} level={1} corners={3}>
                    {/* <video
                      className={classes.falconVideo}
                      id="reveal-video"
                      autoPlay={true}
                      loop
                      muted
                      width="100%"
                      height="100%"
                      preload="auto">
                      <source type="video/webm" src="assets/falcon-video.webm" />
                    </video> */}
                    Falcon9
                    <Image
                      className={classes.falcon9}
                      animate
                      show={anim.entered}
                      resources={this.falcon9}
                    />
                  </Frame>
                </Col>
                <Col s={6} className={classes.fullHeightColumn}>
                  <Frame
                    animate
                    className={classes.frame}
                    show={anim.entered}
                    corners={3}
                    noBackground>
                    <div className={classes.section}>
                      <h1>
                        <Words animate show={anim.entered}>
                          Welcome to Falcon9 Simulator
                        </Words>
                        <Link className={classes.enterButton} href="/panel" onLink={this.onLink}>
                          <Button className={classes.button} animate show={anim.entered}>
                            {anim2 => (
                              <Words animate show={anim2.entered}>
                                Enter
                              </Words>
                            )}
                          </Button>
                        </Link>
                      </h1>
                    </div>
                  </Frame>
                </Col>
              </Row>
            </Content>
          )}
        </Arwes>
      </div>
    );
  }
}

export default withStyles(styles)(Main);
